import React from 'react'
import {Navigate, useLocation} from 'react-router-dom'
import {useAuth} from "../contexts/AuthContext";

export const AuthGuard = ({ children }) => {
  const {currentUser} = useAuth();
  const location = useLocation();
  if (!currentUser && location.pathname !== "/login") {
    return <Navigate to="/login" replace />
  } else if (!currentUser)
    return;

  return children
}
